import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { RecordedCallKey } from 'flow/types/EntityKeys';
import { createRecordedCallTranscription } from 'flow/actions/RecordedCallsActions';
import { selectTranscriptionProgress } from 'flow/selectors/RecordedCallsSelectors';
import { useGetRecordedCallTranscription } from './useGetRecordedCallTranscription';
import { TranscriptionState } from 'flow/types/RecordedCalls';

export const useTranscribeRecordedCallWithProgress = (
    recordedCallKey: RecordedCallKey | undefined,
    isPersonalRecording: boolean | undefined,
) => {
    const dispatch = useAppDispatch();

    const progressState = useAppSelector((state) =>
        selectTranscriptionProgress(state, recordedCallKey),
    );

    const isCompleted = progressState === TranscriptionState.Completed;

    const {
        data: transcription,
        isFetching,
        invalidateCache,
    } = useGetRecordedCallTranscription(
        recordedCallKey,
        isPersonalRecording,
        isCompleted,
    );

    const transcribe = () => {
        return dispatch(
            createRecordedCallTranscription(
                recordedCallKey,
                isPersonalRecording,
            ),
        );
    };

    const refreshTranscription = () => {
        invalidateCache();
        transcribe();
    };

    return {
        data: transcription,
        isFetching: isFetching || progressState === TranscriptionState.Started,
        transcribe,
        refreshTranscription,
        progressState,
    };
};
